export const colorsByStatus: Record<string, Record<'color' | 'bgColor', string>> = {
  active: {
    color: '#33691E',
    bgColor: '#DCEDC8',
  },
  approved: {
    color: '#0057B2',
    bgColor: '#BBDEFB',
  },
  pending_approval: {
    color: '#424242',
    bgColor: '#EEEEEE',
  },
  blocked: {
    color: '#C62828',
    bgColor: '#FFCDD2',
  },
};
